import { render, staticRenderFns } from "./PracticeExams.vue?vue&type=template&id=0709e354&scoped=true"
import script from "./PracticeExams.vue?vue&type=script&lang=js"
export * from "./PracticeExams.vue?vue&type=script&lang=js"
import style0 from "./PracticeExams.vue?vue&type=style&index=0&id=0709e354&prod&scoped=true&lang=css"
import style1 from "./PracticeExams.vue?vue&type=style&index=1&id=0709e354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709e354",
  null
  
)

export default component.exports